import React, { useState, useEffect } from "react";
import Layout from "../../Components/Layout";
import Styles from "./index.module.css";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import { Services } from "../../Services";
import ReactLoading from "react-loading";
import { warningSwal } from "../../Util/Toast";
import Table from "./Table";
import Select from "react-select";
import moment from "moment";

function ParentCreditReport() {
    const { register, handleSubmit, setValue, watch } = useForm();
    const [loading, setLoading] = useState(false);
    const [results, setResults] = useState([]);
    const [link, setLink] = useState("");
    const [parentOptions, setParentOptions] = useState([]);
    const [parentSearch, setParentSearch] = useState("");
    const [selectedParent, setSelectedParent] = useState(null);
    const [parentSearchMeta, setParentSearchMeta] = useState({});
    const token = { Authorization: `token ${localStorage.getItem("token")}` };

    // debounce parent search
    useEffect(() => {
        const id = setTimeout(async () => {
            if (parentSearch && parentSearch.length > 0) {
                try {
                    const res = await Services.ListAllParents(
                        "POST",
                        JSON.stringify({
                            SearchString: parentSearch,
                            Status: "1",
                            toSkip: 0,
                            whether_Email_filter: 1,
                            whether_Mobile_filter: 1,
                            whether_Name_filter: 1,
                        }),
                        token
                    );

                    if (res?.Status === 1) {
                        // API may return parents under `Parents` or `Results`
                        const parentsArray = Array.isArray(res?.Parents)
                            ? res.Parents
                            : Array.isArray(res?.Results)
                            ? res.Results
                            : [];
                        const opts = parentsArray.map((p) => {
                            const name = `${p.FirstName || ""} ${
                                p.LastName || ""
                            }`.trim();
                            return {
                                value: p.ParentID || p.id || p.ParentId,
                                label:
                                    name || p.MobileNumber || p.EmailID || "",
                            };
                        });
                        setParentOptions(opts);
                        // capture extra flags returned by API (toSkip, whether_* etc.) for UI hints
                        setParentSearchMeta({
                            toSkip: res?.toSkip ?? 0,
                            whether_Email_filter:
                                res?.whether_Email_filter ??
                                (res?.whether_Email_filter === 0
                                    ? res?.whether_Email_filter
                                    : undefined),
                            whether_Mobile_filter:
                                res?.whether_Mobile_filter ??
                                (res?.whether_Mobile_filter === 0
                                    ? res?.whether_Mobile_filter
                                    : undefined),
                            whether_Name_filter:
                                res?.whether_Name_filter ??
                                (res?.whether_Name_filter === 0
                                    ? res?.whether_Name_filter
                                    : undefined),
                            Status: res?.Status,
                        });
                    } else {
                        setParentOptions([]);
                        setParentSearchMeta({});
                    }
                } catch (err) {
                    console.error(err);
                    setParentOptions([]);
                    setParentSearchMeta({});
                }
            } else {
                setParentOptions([]);
                setParentSearchMeta({});
            }
        }, 350);
        return () => clearTimeout(id);
    }, [parentSearch]);

    const onSubmit = async (data) => {
        // validate dates
        if (data.FromDate && data.ToDate && data.FromDate > data.ToDate) {
            warningSwal("Warning", "Please select a valid date range");
            return;
        }
        const ParentID = selectedParent?.value || null;
        setLoading(true);
        try {
            const res = await Services.parentwallet_reports(
                "GET",
                null,
                token,
                ParentID,
                data.FilterType || "all",
                data.FromDate || null,
                data.ToDate || null
            );
            setLoading(false);
            if (res?.Status === 1) {
                setLink(res.CsvFile || "");
                // Use Wallets or Results based on API
                setResults(
                    res.Results?.map((item) => ({
                        TransactionDate: item.TransactionDate,
                        "Transaction type": item.TransactionType,
                        "Type Description": item.TypeDescription,
                        Amount: item.Amount,
                        FirstName: item.FirstName,
                        LastName: item.LastName,
                        Email: item.Email,
                        ContactNumber: item.ContactNumber,
                        State: item.State,
                        Country: item.Country,
                    })) ||
                        res.Wallets?.map((item) => ({
                            TransactionDate: item.TransactionDate,
                            "Transaction type": item.TransactionType,
                            "Type Description": item.TypeDescription,
                            Amount: item.Amount,
                            FirstName: item.FirstName,
                            LastName: item.LastName,
                            Email: item.Email,
                            ContactNumber: item.ContactNumber,
                            State: item.State,
                            Country: item.Country,
                        })) ||
                        []
                );
            } else {
                console.error(res);
                warningSwal(
                    "Warning",
                    res?.message || "Failed to fetch report"
                );
            }
        } catch (err) {
            setLoading(false);
            console.error(err);
            warningSwal("Warning", "Something went wrong");
        }
    };

    return (
        <Layout Active={"Parent Credit Report"}>
            <Helmet>
                <meta charSet="utf-8" />
                <title> Parent Credit Report</title>
            </Helmet>
            <div className={Styles["Container"]}>
                <div className={Styles["wrapper"]}>
                    <h3>Parent Credit Report</h3>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className={Styles["form-control"]}>
                            <label>Parent</label>
                            <div className={Styles.parentSelect}>
                                <Select
                                    options={parentOptions}
                                    onInputChange={(val) =>
                                        setParentSearch(val)
                                    }
                                    onChange={(val) => setSelectedParent(val)}
                                    value={selectedParent}
                                    isClearable
                                    placeholder="Search parent by name or phone"
                                />
                            </div>
                            {/* show hints from API about available search filters */}
                            {parentSearchMeta &&
                                parentSearchMeta.Status === 1 && (
                                    <div
                                        style={{
                                            fontSize: 12,
                                            color: "#666",
                                            marginTop: 6,
                                        }}>
                                        {typeof parentSearchMeta.whether_Name_filter !==
                                            "undefined" && (
                                            <span style={{ marginRight: 8 }}>
                                                Name:{" "}
                                                {parentSearchMeta.whether_Name_filter
                                                    ? "Yes"
                                                    : "No"}
                                            </span>
                                        )}
                                        {typeof parentSearchMeta.whether_Email_filter !==
                                            "undefined" && (
                                            <span style={{ marginRight: 8 }}>
                                                Email:{" "}
                                                {parentSearchMeta.whether_Email_filter
                                                    ? "Yes"
                                                    : "No"}
                                            </span>
                                        )}
                                        {typeof parentSearchMeta.whether_Mobile_filter !==
                                            "undefined" && (
                                            <span style={{ marginRight: 8 }}>
                                                Mobile:{" "}
                                                {parentSearchMeta.whether_Mobile_filter
                                                    ? "Yes"
                                                    : "No"}
                                            </span>
                                        )}
                                        {parentSearchMeta.toSkip > 0 && (
                                            <span>More results available</span>
                                        )}
                                    </div>
                                )}
                        </div>

                        <div className={Styles["form-control"]}>
                            <label>From Date</label>
                            <input type="date" {...register("FromDate")} />
                        </div>
                        <div className={Styles["form-control"]}>
                            <label>To Date</label>
                            <input type="date" {...register("ToDate")} />
                        </div>
                        <div className={Styles["form-control"]}>
                            <label>Filter Type</label>
                            <select
                                {...register("FilterType")}
                                defaultValue={"all"}>
                                <option value="all">All</option>
                                <option value="credited">Credited</option>
                                <option value="debited">Debited</option>
                            </select>
                        </div>

                        <div
                            style={{
                                display: "flex",
                                gap: 8,
                                alignItems: "center",
                            }}>
                            {/** determine current filter type to style buttons */}
                            {/** watch returns the current value of FilterType */}
                            {(() => {
                                const currentFilter = (
                                    watch("FilterType") || "all"
                                )
                                    .toString()
                                    .toLowerCase();
                                const submitClass = `${Styles.btn} ${
                                    currentFilter === "credited"
                                        ? Styles.btnSuccess
                                        : currentFilter === "debited"
                                        ? Styles.btnDanger
                                        : Styles.btnPrimary
                                }`;
                                const exportClass = `${Styles.btn} ${
                                    currentFilter === "credited"
                                        ? Styles.btnSuccess
                                        : currentFilter === "debited"
                                        ? Styles.btnDanger
                                        : Styles.btnExport
                                }`;

                                return (
                                    <>
                                        <button
                                            type="submit"
                                            disabled={loading}
                                            className={submitClass}
                                            aria-busy={loading}>
                                            <span
                                                style={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: 8,
                                                }}>
                                                {loading && (
                                                    <ReactLoading
                                                        type="spokes"
                                                        color="#fff"
                                                        height={14}
                                                        width={14}
                                                    />
                                                )}
                                                {loading
                                                    ? "Submitting..."
                                                    : "Submit"}
                                            </span>
                                        </button>

                                        {link && (
                                            <button
                                                type="button"
                                                className={exportClass}
                                                onClick={() =>
                                                    window.open(link, "_blank")
                                                }>
                                                Export
                                            </button>
                                        )}
                                    </>
                                );
                            })()}
                        </div>
                    </form>

                    {results && results.length > 0 && (
                        <div style={{ overflow: "auto", marginTop: 16 }}>
                            <Table
                                data={results}
                                style={{ minWidth: "1500px" }}
                            />
                        </div>
                    )}
                </div>
            </div>
        </Layout>
    );
}

export default ParentCreditReport;
